/***
 * 自定义函数service
 */
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FunctionService {

  constructor() {
  }

  /**
   * 删除符合条件的数组子元素
   * @param data
   * @param key
   * @param conditions
   */
  async deleteObjectItem(data: any, key: string, conditions: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      const response: any = [];
      for (const i of data) {
        if (i[key] != conditions) {
          response.push(i);
        } 
      }
      resolve(response);
    });
  }
}
